import React, { useState } from "react";
import axios from "axios";

import AppBar from "@material-ui/core/AppBar";
import { LogoNavBar } from "../components/Logo/LogoKP.jsx";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { Box, makeStyles, useTheme } from "@material-ui/core";
import { getMenu } from "../config/menu";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { vars } from "../config/theme";
import api from "../config/api";
import { ReportGenerator } from "../utils/createReport";

const Authorized = (props) => {
    const theme = useTheme();
    const isAdmin = props.user?.type === "admin";

    const [mobileOpen, setMobileOpen] = React.useState(false);
    // сворачивание меню тру - развернуто

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawerWidth = props.openLeftMenu ? 240 : 50;

    const useStyles = makeStyles((theme) => ({
        root: {
            display: "flex",
        },
        drawer: {
            [theme.breakpoints.up("sm")]: {
                width: drawerWidth,
                flexShrink: 0,
            },
        },
        appBar: {
            [theme.breakpoints.up("sm")]: {
                width: `calc(100% - ${drawerWidth}px)`,
                marginLeft: drawerWidth,
            },
            backgroundColor:
                props?.hotelColor ?? props?.hotel?.color_main ?? "white",
        },
        menuButton: {
            marginRight: theme.spacing(2),
            [theme.breakpoints.up("sm")]: {
                display: "none",
            },
        },
        // necessary for content to be below app bar
        toolbar: theme.mixins.toolbar,
        drawerPaper: {
            width: drawerWidth,
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
    }));

    const classes = useStyles();

    async function createReportFromData() {
        const reportGenerator = new ReportGenerator();

        const response = await axios.get(`${api.baseUrl}/get_history_quotas`);
        const data = response.data;

        const reportData = [
            ["Отель", "Квота", "Дата квоты", "Время закрытия", "Пользователь"],
        ];

        for (const item of data) {
            const date = new Date(item.created_at);
            const quotaDate = new Date(item.quota_date);
            const formattedQuotaDate = `${quotaDate.getDate()}.${quotaDate.getMonth() + 1}.${quotaDate.getFullYear()}`;
            const formattedDate = `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
            const rowData = [
                item.hotel_name,
                item.room_type_name,
                formattedQuotaDate,
                formattedDate,
                item.user_name,
            ];
            reportData.push(rowData);
        }

        const workbook = reportGenerator.createReport(reportData);
        reportGenerator.downloadReport(workbook, "quotas_report.xlsx");
    }

    let userMenu = getMenu(props.user.type);

    const handleToggle = () => {
        props.setOpenLeftMenu(!props.openLeftMenu);
    };

    const logout = () => {
        axios
            .get(`${api.baseUrl}/logout`)
            .then((response) => {
                if (response.status == 200) {
                    props.setUser(null);
                    props.setHotel(null);
                    alert(response.data.message);
                }
            })
            .catch(() => alert("Ошибка выхода!"));
    };

    if (["spir_apart", "Test_zayavka"].includes(props?.user?.name)) {
        userMenu = {
            Заявки: "reservations",
        };
    }

    const drawer = (
        <div>
            <List>
                <ListItem button onClick={handleToggle}>
                    <img
                        style={{
                            margin: "0 15px 0 -12px",
                            width: "25px",
                            opacity: "0.5",
                        }}
                        src="/icons/scroll.png"
                    />
                    {props.openLeftMenu && <ListItemText primary="Меню" />}
                </ListItem>
            </List>
            <List>
                {Object.keys(userMenu).map((title) => {
                    const hotelDependantMenuItem = checkMenuItemType(
                        props.user.type,
                        userMenu[title],
                    );
                    return (
                        <>
                            {title == "Торговые группы" && <Divider />}
                            <ListItem
                                disabled={props.inactiveMenu}
                                button
                                key={title}
                                component={NavLink}
                                activeStyle={{
                                    borderLeft: `4px solid ${vars.kpRed}`,
                                }}
                                to={`/${userMenu[title]}`}
                                isActive={(_, location) => {
                                    const isActive = showActive(
                                        location,
                                        userMenu[title],
                                    );
                                    return isActive;
                                }}
                            >
                                <img
                                    style={{
                                        marginLeft: "-15px",
                                        width: "25px",
                                        opacity: "0.5",
                                    }}
                                    src={`/icons/${userMenu[title]}.png`}
                                />

                                {props.openLeftMenu && (
                                    <Box mt={".25rem"} mb={".25rem"}>
                                        <Typography
                                            style={{ marginLeft: "1rem" }}
                                        >
                                            {title}
                                        </Typography>
                                    </Box>
                                )}
                                <ListItemText />
                            </ListItem>
                        </>
                    );
                })}
            </List>
            {isAdmin && (
                <>
                    <Divider />
                    <List>
                        <ListItem button onClick={createReportFromData}>
                            <img
                                style={{
                                    width: "25px",
                                    marginLeft: "-12px",
                                    marginRight: "15px",
                                    opacity: "0.5",
                                }}
                                src="/icons/report.svg"
                            />
                            {props.openLeftMenu && (
                                <ListItemText primary="Отчет" />
                            )}
                        </ListItem>
                    </List>
                </>
            )}
            <Divider />
            <List>
                <ListItem button onClick={logout}>
                    <img
                        style={{
                            width: "25px",
                            marginLeft: "-12px",
                            marginRight: "15px",
                            opacity: "0.5",
                        }}
                        src="/icons/exit.png"
                    />
                    {props.openLeftMenu && <ListItemText primary="Выход" />}
                </ListItem>
            </List>
        </div>
    );

    return (
        <div className={classes.root}>
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        className={classes.menuButton}
                    >
                        <MenuIcon />
                    </IconButton>
                    <LogoNavBar
                        logo={props?.hotelLogo ?? props?.hotel?.logo_address}
                    />
                    <Typography>{props?.hotelName}</Typography>
                </Toolbar>
            </AppBar>
            <nav className={classes.drawer} aria-label="mailbox folders">
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Hidden smUp implementation="css">
                    <Drawer
                        variant="temporary"
                        anchor={theme.direction === "rtl" ? "right" : "left"}
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden xsDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        variant="permanent"
                        open
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
            </nav>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                {props.children}
            </main>
        </div>
    );
};

// Helper functions

/**
 * Check menu item type
 *
 * @param {String} userType
 * @param {String} menuItemName
 */

const checkMenuItemType = (userType, menuItemName) => {
    if (userType === "manager") {
        switch (menuItemName) {
            case "hotels":
                return false;
            case "reports":
                return false;
            default:
                return true;
        }
    }
    return false;
};

/**
 * Returns true if menu option is active
 *
 * @param {Array} location
 * @param {String} menuTitle
 */

const showActive = (location, menuTitle) => {
    const locArray = location.pathname.split("/");
    const menuRequest = locArray[locArray?.length - 1];
    const arrForCheckOneWordBefore = [
        "add",
        "chess",
        "chessxlsx",
        "period",
        "periodxlsx",
    ];
    const checkedMenuRequest =
        !isNaN(parseInt(menuRequest)) ||
        arrForCheckOneWordBefore.includes(menuRequest)
            ? locArray[locArray?.length - 2]
            : menuRequest === "edit"
              ? locArray[locArray?.length - 3]
              : locArray[locArray?.length - 1];

    if (
        checkedMenuRequest === menuTitle ||
        (menuTitle === "operators" && checkedMenuRequest === "users")
    ) {
        return true;
    }
};

Authorized.propTypes = {
    children: PropTypes.element,
    user: PropTypes.object.isRequired,
    inactiveMenu: PropTypes.bool.isRequired,
    setUser: PropTypes.func,
    setHotel: PropTypes.func,
    hotelName: PropTypes.string,
};

export default Authorized;
